/* ---- Be Neo Astaxanthin — caixa de compra da PDP (16/10/2026) -------------
   Pagina no layout da ClarityMD (ver o comentario de sections/astaxanthin-pdp.liquid).
   A logica de compra e a da sub7 (`brainmag-sub5.js`), num arquivo proprio
   porque a caixa e outra (cards compactos 1/3/5, botao com preco, link avulso
   com frete), e editar o JS da sub7, que esta no ar, seria interferencia.

     - com selling plan na variante, o botao vende a ASSINATURA (refil a cada
       30 dias) e o link "One Time Purchase" vende o avulso, sem plano;
     - sem selling plan na loja (Kaching ainda nao ligado), a pagina vende so
       compra unica: cards e botao com o preco avulso, link e "refills" somem;
     - o RISCADO e o "Save X%" saem do compare_at da variante (ancora fixa, uma
       por card, a mesma do botao) — nunca de numero escrito aqui;
     - o carrinho passa SEMPRE pelo `carrinhoSubstitui` (esvazia, adiciona,
       confere) — regra do repo, travada em tests/carrinho-substitui.test.js;
     - propriedades ocultas: `_pagina` (separa no BI), `_guarantee`, `_you_save`;
     - brinde (16/10): na ASSINATURA entra uma segunda linha a $0,00 com os 3
       e-books (SKU GIFT-ASTAX-EBOOKS, variante vinda de #ax-gift-data), sem
       selling_plan — nao recorre. O avulso nao leva ("No Free Gifts Included").
       O link dos PDFs nao passa por aqui: vai no e-mail de confirmacao.
     - gratis so no 1o pedido (19/10): com #ax-split-data, o card "Buy 2, Get 1
       Free" (qty 3) ASSINA a variante de 2 pouches e leva 1 pouch de $0 sem
       selling_plan; o de 5 assina 3 e leva 2. Antes assinava 3/5 e a renovacao
       repetia os gratis todo mes. Sem o JSON, cada card assina a propria qtd.
   -------------------------------------------------------------------------- */
(function () {
  var D = {};          /* qty -> assinatura {variantId, price, compare, ship, avail, plan} */
  var O = {};          /* qty -> avulso {variantId, price, compare, ship, avail} */
  var GIFT = null;     /* variante do brinde (e-books), so na assinatura */
  var BONUS = null;    /* variante do pouch gratis ($0), so no 1o pedido */
  var SPLIT = {};      /* card -> {base: pouches recorrentes, free: gratis no 1o pedido} */
  var QTYS = [];
  var qty = 0;
  var PAGINA = 'astaxanthin';
  var GARANTIA = 90;
  var UN1 = 'Pouch', UNN = 'Pouches';

  function usd(n) {
    var c = window.Shopify && Shopify.currency && Shopify.currency.active;
    return ({ GBP: '£', EUR: '€' }[c] || '$') + n.toFixed(2);
  }
  function lerJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function texto(el, t) { if (el) el.textContent = t; }

  function read() {
    var g = lerJson('ax-gift-data');
    GIFT = g && g.variantId ? g.variantId : null;
    var sp = lerJson('ax-split-data');
    if (sp && sp.bonusVariantId && sp.map) {
      BONUS = sp.bonusVariantId;
      String(sp.map).split(',').forEach(function (par) {
        var m = /^\s*(\d+)\s*:\s*(\d+)\s*\+\s*(\d+)\s*$/.exec(par);
        if (m) SPLIT[+m[1]] = { base: +m[2], free: +m[3] };
      });
    }
    var a = lerJson('lp-offer-data');
    if (a && a.items) {
      a.items.forEach(function (it) {
        if (!it.qty) return;
        D[it.qty] = {
          variantId: it.variantId,
          price: (it.plan && it.plan.price != null ? it.plan.price : it.oncePrice) / 100,
          compare: it.comparePrice ? it.comparePrice / 100 : 0,
          ship: parseFloat(it.ship) || 0,
          avail: it.available !== false,
          plan: it.plan || null
        };
        if (QTYS.indexOf(it.qty) < 0) QTYS.push(it.qty);
      });
    }
    var b = lerJson('lp-once-data');
    if (b && b.items) {
      b.items.forEach(function (it) {
        if (!it.qty) return;
        O[it.qty] = {
          variantId: it.variantId,
          price: it.oncePrice / 100,
          compare: it.comparePrice ? it.comparePrice / 100 : 0,
          ship: parseFloat(it.ship) || 0,
          avail: it.available !== false
        };
        if (QTYS.indexOf(it.qty) < 0) QTYS.push(it.qty);
      });
    }
    QTYS.sort(function (x, y) { return x - y; });
    return QTYS.length > 0;
  }

  /* Assinatura de verdade: ha plano na variante. Senao, o card e do avulso. */
  function temPlano(d) { return !!(d && d.plan && d.plan.id); }
  /* Divisao do card q valida so se a variante recorrente existe com plano. */
  function div(q) { var s = SPLIT[q]; return s && BONUS && temPlano(D[s.base]) ? s : null; }
  function sd(q) { var s = div(q); return s ? D[s.base] : D[q]; }
  function emSub(q) { return temPlano(sd(q)); }
  function ativo(q) { return emSub(q) ? sd(q) : (O[q] || D[q]); }
  function pct(preco, cheio) { return cheio > preco ? Math.round((1 - preco / cheio) * 100) : 0; }

  function render() {
    document.querySelectorAll('[data-ax-qty]').forEach(function (card) {
      var q = +card.getAttribute('data-ax-qty');
      var d = ativo(q);
      card.hidden = !d;
      if (!d) return;
      card.setAttribute('aria-selected', q === qty ? 'true' : 'false');
      texto(card.querySelector('[data-ax-price]'), usd(d.price));
      texto(card.querySelector('[data-ax-was]'), d.compare > d.price ? usd(d.compare) : '');
      var p = pct(d.price, d.compare);
      var s = p ? 'Save ' + p + '%' : '';
      if (!d.ship && q > 1) s += (s ? ' + ' : '') + 'FREE Shipping!';
      texto(card.querySelector('[data-ax-save]'), s);
    });

    /* "TODAY ONLY" da oferta especial: o preco de 1 pouch que se paga hoje
       (assinatura com plano, avulso sem plano) — nunca o do Liquid sozinho. */
    var hoje = ativo(1);
    if (hoje) texto(document.querySelector('[data-ax-today]'), usd(hoje.price));

    var d = ativo(qty);
    if (!d) return;
    texto(document.querySelector('[data-ax-btn-price]'), usd(d.price));
    texto(document.querySelector('[data-ax-btn-was]'), d.compare > d.price ? usd(d.compare) : '');
    var btn = document.getElementById('ax-buy-btn');
    if (btn) btn.disabled = !d.avail;

    var sub = emSub(qty);
    var linha = document.querySelector('[data-ax-subline]');
    if (linha) linha.hidden = !sub;
    var dv = sub ? div(qty) : null;
    texto(document.querySelector('[data-ax-refill]'), '\u21bb ' + (dv
      ? 'Then ' + dv.base + ' ' + (dv.base === 1 ? UN1 : UNN) + ' Every 30 Days'
      : 'Refills Ship Every 30 Days'));
    var rec = document.querySelector('[data-ax-rec]');
    if (rec) rec.hidden = !(sub && O[qty]);
    var once = document.getElementById('ax-once');
    if (once) {
      var o = O[qty];
      once.hidden = !(sub && o);
      if (o) {
        once.textContent = 'One Time Purchase ' + usd(o.price) +
          (o.ship ? ' + ' + usd(o.ship) + ' Shipping' : ' + Free Shipping') +
          ' (No Free Gifts Included).';
        once.disabled = !o.avail;
      }
    }
  }

  function say(msg) {
    var el = document.getElementById('ax-err');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  function props(sub) {
    var p = {};
    var d = sub ? sd(qty) : O[qty];
    if (sub && d && d.compare > d.price) p['_you_save'] = usd(d.compare - d.price) + ' off the regular price';
    p['_guarantee'] = GARANTIA + '-day money-back guarantee';
    p['_pagina'] = PAGINA;
    return p;
  }

  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  /* `avulsa` = veio do link One Time Purchase. Senao, o botao: assinatura
     quando ha plano, avulso quando nao ha. */
  function buy(ev, avulsa) {
    if (ev) ev.preventDefault();
    var sub = !avulsa && emSub(qty);
    var d = sub ? sd(qty) : (O[qty] || D[qty]);
    if (!d) return say('Pick a bundle');
    var alvo = document.getElementById(avulsa ? 'ax-once' : 'ax-buy-btn');
    if (alvo) alvo.setAttribute('aria-busy', 'true');
    var item = { id: d.variantId, quantity: 1, properties: props(sub) };
    if (sub) item.selling_plan = d.plan.id;
    var itens = [item];
    var dv = sub ? div(qty) : null;
    if (dv && dv.free) itens.push({ id: BONUS, quantity: dv.free, properties: { '_pagina': PAGINA } });
    if (sub && GIFT) itens.push({ id: GIFT, quantity: 1, properties: { '_pagina': PAGINA } });
    adicionar(itens)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (alvo) alvo.removeAttribute('aria-busy');
        console.error('[astaxanthin-pdp] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart — try again');
      });
  }

  /* ---- RedTrack: viewcontent — copia do `brainmag-sub5.js` (o porque esta
     la: o events.js nao dispara em /pages sem form de carrinho). ---------- */
  function redtrackViewContent(tentativa) {
    var tag = document.querySelector('script[src*="/events.js"]');
    if (!tag || !tag.src) return;
    var host = tag.src.split('/').slice(0, 3).join('/');
    var id = null;
    var m = /(?:^|; )rtkclickid-store=([^;]*)/.exec(document.cookie || '');
    if (m) id = decodeURIComponent(m[1]);
    if (!id || id === 'undefined') {
      try { id = window.sessionStorage.getItem('rtkclickid'); } catch (e) { id = null; }
    }
    if (!id || id === 'undefined') {
      if ((tentativa || 0) < 30) setTimeout(function () { redtrackViewContent((tentativa || 0) + 1); }, 1000);
      return;
    }
    var x = new XMLHttpRequest();
    x.open('GET', host + '/postback?clickid=' + encodeURIComponent(id) +
      '&type=viewcontent&eventid=' + encodeURIComponent(id));
    x.send();
    var c = new XMLHttpRequest();
    c.open('POST', '/cart/update.js');
    c.setRequestHeader('Content-Type', 'application/json');
    c.send(JSON.stringify({ attributes: { '__clickid': id } }));
  }

  function gallery() {
    var slides = document.querySelectorAll('[data-ax-slide]');
    var thumbs = document.querySelectorAll('[data-ax-thumb]');
    var strip = document.querySelector('.thumbs');
    var main = document.querySelector('[data-ax-main]');
    if (!slides.length) return;
    var at = 0;
    function show(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.setAttribute('data-on', n === at ? '1' : '0'); });
      if (main) main.setAttribute('data-at', String(at));
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === at ? 'true' : 'false'); });
      var t = thumbs[at];
      if (t && strip && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = document.querySelector('[data-ax-prev]');
    var next = document.querySelector('[data-ax-next]');
    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
    show(0);
  }

  function extras() {
    /* Botoes "Buy now" do meio da pagina: rolam ate a caixa de compra. */
    document.querySelectorAll('[data-ax-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var box = document.getElementById('ax-buy');
        if (!box) return;
        e.preventDefault();
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var modal = document.querySelector('[data-ax-facts]');
    var abre = document.querySelector('[data-ax-facts-open]');
    var fecha = document.querySelector('[data-ax-facts-close]');
    if (modal && abre) abre.addEventListener('click', function () { modal.hidden = false; });
    if (modal && fecha) fecha.addEventListener('click', function () { modal.hidden = true; });
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.hidden = true; });
  }

  function init() {
    var box = document.querySelector('[data-ax-pagina]');
    if (box) {
      PAGINA = box.getAttribute('data-ax-pagina') || PAGINA;
      GARANTIA = parseInt(box.getAttribute('data-ax-garantia'), 10) || GARANTIA;
    }
    var un = lerJson('mm-unidade');
    if (un && un.one && un.many) { UN1 = un.one; UNN = un.many; }
    gallery();
    extras();
    redtrackViewContent(0);
    if (!read()) return;
    var flag = document.querySelector('[data-ax-qty][data-ax-default]');
    qty = flag && ativo(+flag.getAttribute('data-ax-qty')) ? +flag.getAttribute('data-ax-qty') : QTYS[0];
    document.querySelectorAll('[data-ax-qty]').forEach(function (card) {
      card.addEventListener('click', function () { qty = +card.getAttribute('data-ax-qty'); render(); });
    });
    var b = document.getElementById('ax-buy-btn');
    if (b) b.addEventListener('click', function (e) { buy(e, false); });
    var o = document.getElementById('ax-once');
    if (o) o.addEventListener('click', function (e) { buy(e, true); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (b) b.removeAttribute('aria-busy');
      if (o) o.removeAttribute('aria-busy');
    });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
